import { IconButton } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import React from "react";
import { ReactComponent as CloseIcon } from "../../themes/Icons/close_icon.svg";
import {
  ButtonReadMoreCancel,
  CloseModalReadMore,
  ContentModalReadMore,
  TextModalReadMore,
} from "./ModalDetailMyCoach.styled";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import PortalModal from "../../Portals";

const ModalDetailMyCoach = ({ openReadMoreModal, setOpenReadMoreModal }) => {
  return (
    <PortalModal>
      <ContentModalReadMore>
        <CloseModalReadMore>
          <span style={{ marginLeft: "0.2em" }}>
            {openReadMoreModal.firstName + " " + openReadMoreModal.lastName}
          </span>
          <Tooltip title="close">
            <IconButton onClick={() => setOpenReadMoreModal(null)}>
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </CloseModalReadMore>
        <TextModalReadMore>
          <p>
            <b>Introduction:</b> {openReadMoreModal.description}
          </p>
          <p>
            <b>Profession:</b> {openReadMoreModal.position}
          </p>
          <p>
            <b>Years of experience:</b> {openReadMoreModal.yearsOfExperience}
          </p>
          <p>
            <b>Tenure in TP:</b> {openReadMoreModal.yearsInTp}
          </p>
          <p
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <MailOutlineIcon style={{ width: "0.8em", marginRight: "0.2em" }} />{" "}
            {openReadMoreModal.emailAddress}
          </p>
        </TextModalReadMore>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <ButtonReadMoreCancel onClick={() => setOpenReadMoreModal(null)}>
            Close
          </ButtonReadMoreCancel>
        </div>
      </ContentModalReadMore>
    </PortalModal>
  );
};
export default ModalDetailMyCoach;
